import { refreshAccessToken } from '@/shared/api/refreshToken';
import { useAuthStore } from '@/shared/stores/authStore';

import { fetchMe, meToAuthUser } from './queries';

let bootstrapPromise: Promise<void> | null = null;

/// Runs ONCE on app boot, before the route guards decide anything: if the
/// httpOnly refresh cookie is still valid, mint a fresh access token and
/// rehydrate the principal (via /auth/me) so a browser refresh restores the
/// session instead of bouncing the user to the login screen. The access token
/// itself is never persisted to storage — only the rotating cookie is trusted.
///
/// Memoised so concurrent guards await a single call; failures are swallowed
/// (no valid cookie → store stays cleared → normal redirect to login).
export function ensureAuthBootstrapped(): Promise<void> {
  if (!bootstrapPromise) {
    bootstrapPromise = (async () => {
      // A live session already exists (e.g. we just logged in) — skip the trip.
      if (useAuthStore.getState().isAuthenticated) return;
      try {
        const token = await refreshAccessToken();
        if (!token) return;
        const user = meToAuthUser(await fetchMe());
        if (user) useAuthStore.getState().setSession(token, user);
      } catch {
        /* no valid refresh cookie / refresh failed → remain logged out */
      }
    })();
  }
  return bootstrapPromise;
}
